import script from "./BlackBoxSSRTool.vue?vue&type=script&setup=true&lang=js"
export * from "./BlackBoxSSRTool.vue?vue&type=script&setup=true&lang=js"

import "./BlackBoxSSRTool.vue?vue&type=style&index=0&id=3c65c903&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c65c903"]])

export default __exports__